import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { Button } from '@blueprintjs/core';
import { PRINT, CLOUD_DOWNLOAD } from '@blueprintjs/icons/lib/esm/generated/iconNames';
import { observer } from 'mobx-react';
import BaseGrid from '../common/grid/BaseGrid';
import styled from '@emotion/styled';
import RadioGroupFormField from '../common/form/RadioGroupFormField';
import RadioInput from '../common/input/basicInputs/RadioInput';
import { Form } from 'react-final-form';
import moment from 'moment';
import { renderGridDate } from '../../store/utils';
import { DutyAssignmentSearchCriteria } from '../../store/DutyAssignmentStore';
import { PharmacyDetails } from '../../store/models/PharmacyDetails';
import { Instance } from 'mobx-state-tree';
import { SystemStatus } from '../../store/models/SystemStatus';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

interface PharmacyDutyRosterProps {
  getDutyRosterReport: (criteria: DutyAssignmentSearchCriteria) => void;
  pharmacyId: number;
  pharmacyDetails?: Instance<typeof PharmacyDetails>;
  systemStatus: Array<Instance<typeof SystemStatus>>;
}

interface PharmacyDutyRosterState {
  searchCriteria: string;
  isLoading: boolean;
}

const CenterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const RowActions = (props: {
  criteria: DutyAssignmentSearchCriteria;
  getDutyRosterReport: (criteria: DutyAssignmentSearchCriteria) => void;
}) => {
  const { criteria, getDutyRosterReport } = props;
  return (
    <CenterContainer>
      <Button minimal={true} icon={PRINT} onClick={() => {
        getDutyRosterReport(criteria)
        }} />
    </CenterContainer>
  );
};

@observer
class PharmacyDutyRoster extends React.Component<
  PharmacyDutyRosterProps & WithTranslateProps,
  PharmacyDutyRosterState
> {
  state = {
    searchCriteria: 'ALL',
    isLoading: false,
  } as PharmacyDutyRosterState;

  columns = [
    { headerName: this.props.translate(TLCode.PHARMACY_DUTY_ROSTER_NumWeek), field: 'week', width: 35 },
    {
      headerName: this.props.translate(TLCode.PHARMACY_DUTY_ROSTER_From),
      field: 'startDate',
      width: 65,
      cellRenderer: renderGridDate,
    },
    {
      headerName: this.props.translate(TLCode.PHARMACY_DUTY_ROSTER_To),
      field: 'endDate',
      width: 65,
      cellRenderer: renderGridDate,
    },
    {
      width: 50,
      headerName: this.props.translate(TLCode.PHARMACY_DUTY_ROSTER_Print),
      sortable: false,
      filter: false,
      cellRendererFramework: RowActions,
      cellRendererParams: (params: ICellRendererParams) => {
        return {
          criteria: {
            startDate: params.data.startDate,
            endDate: params.data.endDate,
            pharmacyIdForNeighbor: this.props.pharmacyId,
          },
          getDutyRosterReport: this.props.getDutyRosterReport,
        };
      },
    },
    {

    }
  ] as ColDef[];

  handlePrint = (criteria) => {
    this.props.getDutyRosterReport(criteria);
  };

  buildGridData = () => {
    const result: any[] = [];
    const mondayThisWeek = moment().startOf('isoWeek').add(6,'hours');
    const sundayThisWeek = moment()
      .startOf('isoWeek')
      .add(6, 'd').add(6,'hours');
    let week = moment().week();

    const lastPublishedDuty = this.props.systemStatus.find((elem) => elem.subSystem === 'LastPublishedDuty');
    const endingDate = moment(lastPublishedDuty!.status, 'DD/MM/YYYY').add(7,'d');
    switch (this.state.searchCriteria) {
      case 'THIS_WEEK':
        result.push({
          id: week,
          week,
          startDate: mondayThisWeek.format(),
          endDate: sundayThisWeek.format(),
        });
        break;
      case 'NEXT_WEEK':
        result.push({
          id: week,
          week: week + 1,
          startDate: mondayThisWeek.add(7, 'd').format(),
          endDate: sundayThisWeek.add(7, 'd').format(),
        });
        break;
      default:
        for (let i = 1; i < 54; i++) {
          result.push({
            id: i,
            week,
            startDate: mondayThisWeek.format(),
            endDate: sundayThisWeek.format(),
          });
          // week++;
          week = 1 + (week++ % 53);
          mondayThisWeek.add(7, 'd');
          sundayThisWeek.add(7, 'd');
          console.log(mondayThisWeek.format());

          console.log(endingDate.format());
          if (mondayThisWeek.isSameOrAfter(endingDate)) {
            break;
          }
          if (sundayThisWeek.isSameOrAfter(endingDate)) {
            break;
          }
        }
    }
   
    return result;
  };

  handleChangeValue = (value) => {
    this.setState({ searchCriteria: value });
  };

  render() {
    const { pharmacyDetails } = this.props;
    return (
      <Container>
        <b>
          ({pharmacyDetails!.level})&nbsp;&nbsp;{pharmacyDetails!.apbNumber}&nbsp;-&nbsp;{pharmacyDetails!.name}
          &nbsp;-&nbsp;{pharmacyDetails!.address},&nbsp;
          {pharmacyDetails!.zipCode}&nbsp;
          {pharmacyDetails!.city}
        </b>
        <br />
        <Form
          initialValues={{ searchCriteria: this.state.searchCriteria }}
          onSubmit={(data: any) => console.log('data', data)}
          render={({ handleSubmit, form, hasValidationErrors, dirty, values }) => (
            <form onSubmit={handleSubmit}>
              {/* <RadioGroupFormField name={'searchCriteria'} onChange={this.handleChangeValue}> */}
                {/* <RadioInput key={'ALL'} label={TLCode.PHARMACY_DUTY_ROSTER_AllRoster} value="ALL" /> */}
                {/* <RadioInput key={'THIS_WEEK'} label={TLCode.PHARMACY_DUTY_ROSTER_RosterThisWeek} value="THIS_WEEK" />
                <RadioInput key={'NEXT_WEEK'} label={TLCode.PHARMACY_DUTY_ROSTER_RosterNextWeek} value="NEXT_WEEK" /> */}
              {/* </RadioGroupFormField> */}
            </form>
          )}
        />
        <BaseGrid columnDefs={this.columns} rowData={this.buildGridData()} keyName={'id'} />
      </Container>
    );
  }
}

export default withTranslate(PharmacyDutyRoster);
